export type AuthLevel = "public" | "private" | "client" | "admin";

type AuthUser = {
  type?: "client" | "admin";
  accountType?: "client" | "admin";
} | null | undefined;

export const isAuthorizedToViewContent = (auth: AuthLevel, user: AuthUser) => {
  const accountType = user?.type ?? user?.accountType;
  if (auth === "public") return true;
  if (auth === "private" && user) return true;
  if (auth === accountType) return true;

  return false;
};
